export const DEVICE_TYPE: Record<number, string> = {
  0: "UNKNOWN",
  1: "PHONE",
  2: "TABLET",
  3: "DESKTOP",
  4: "TV",
};
